import { AutonomyMeasurementsStep } from "./AutonomyMeasurementsStep";
import { BasicInfoStep } from "./BasicInfoStep";
import { PtoStep } from "./PtoStep";
import { ScvStep } from "./ScvStep";
import React, { FC } from "react";

export const ReviewStep: FC<{ disabled?: boolean }> = ({ disabled }) => {
  return (
    <div className="flex flex-col gap-4">
      <BasicInfoStep disabled={disabled} />
      <AutonomyMeasurementsStep disabled={disabled} />
      <PtoStep disabled={disabled} />
      <ScvStep disabled={disabled} />
    </div>
  );
};
